import { createCtx } from '@nic/commons'
import { requestCandidateContactInitialState, requestCandidateContactReducer } from '@nic/nic-api'

const [ctx, Provider] = createCtx(
  requestCandidateContactReducer,
  requestCandidateContactInitialState
)
export const CandidateRegistrantContext = ctx
export const CandidateRegistrantProvider = Provider
